import {
	NEW,
	NEW_AND_MODIFIED,
	EXISTING_AND_MODIFIED,
} from '../../../../../../../../common/ui/constants.tsx';

export const getNextGoalState = (previousGoalState?: string): string => {
	// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
	if ([NEW, NEW_AND_MODIFIED].includes(previousGoalState)) {
		return NEW_AND_MODIFIED;
	}

	return EXISTING_AND_MODIFIED;
};
